module.exports = __webpack_public_path__ + "img/scratch.284a5541.png";